<script lang="ts">
</script>

<style lang="scss">
  .filter-option {
    &--container-options {
      padding: 32px 16px;
    }
  }
</style>

<div class="filter-option--container-options">
  <slot />
</div>
